import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ClaimGuard, WorkflowMonitorGuard } from '@lsq-frontend/common-ui';
import { Routes } from '@lsq-frontend/common-ui';
import { invoicesAtlas } from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { InvoiceDetailComponent } from './invoice-detail/invoice-detail.component';
import { UploadInvoicesComponent } from './upload-invoices/upload-invoices.component';

export const invoicesRoutes: Routes = [
    {
        path: invoicesAtlas.INVOICES_UPLOAD.path,
        component: UploadInvoicesComponent,
        canActivate: [ClaimGuard],
        canDeactivate: [WorkflowMonitorGuard],
        data: {
            title: invoicesAtlas.INVOICES_UPLOAD.title,
            claims: invoicesAtlas.INVOICES_UPLOAD.claims
        }
    },
    {
        path: invoicesAtlas.INVOICES_INVOICE.path,
        component: InvoiceDetailComponent,
        canActivate: [ClaimGuard],
        data: {
            title: invoicesAtlas.INVOICES_INVOICE.title,
            claims: invoicesAtlas.INVOICES_INVOICE.claims
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(invoicesRoutes)],
    exports: [RouterModule]
})
export class InvoicesRoutingModule {}
